import React, { useState } from "react";

export interface LikeButtonProps {
  className?: string;
  liked?: boolean;
}

const LikeButtonNew: React.FC<LikeButtonProps> = ({
  className = "",
  liked = Math.random() > 0.6,
}) => {
  const [isLiked, setIsLiked] = useState(liked);

  return (
    <button
      className={`w-9 h-9 flex items-center justify-center rounded-full bg-white dark:bg-slate-900 text-neutral-700 dark:text-slate-200 nc-shadow-lg ${className}`}
      onClick={() => setIsLiked(!isLiked)}
    >
      {/* <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none">
        <path
          d="M12.62 20.81C12.28 20.93 11.72 20.93 11.38 20.81C8.48 19.82 2 15.69 2 8.68998C2 5.59998 4.49 3.09998 7.56 3.09998C9.38 3.09998 10.99 3.97998 12 5.33998C13.01 3.97998 14.63 3.09998 16.44 3.09998C19.51 3.09998 22 5.59998 22 8.68998C22 15.69 15.52 19.82 12.62 20.81Z"
          stroke={isLiked ? "#ef4444" : "currentColor"}
          fill={isLiked ? "#ef4444" : "none"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg> */}
        {/* <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <circle cx="16" cy="16" r="16" fill="#E6EFFB"></circle>
    </svg> */}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      stroke={isLiked ? "#ef4444" : "currentColor"}
      width="18"
      height="17"
      fill={isLiked ? "#ef4444" : "none"}
      viewBox="0 0 18 17"
    >
      <path
        fill="#151515"
        d="M17.889 6.547l-6.391-.551L9 .11 6.502 6.005l-6.39.542 4.852 4.204-1.457 6.25L9 13.684 14.493 17l-1.449-6.249 4.845-4.204zM9 12.022L5.658 14.04l.889-3.804-2.951-2.56 3.893-.338L9 3.756l1.52 3.59 3.893.339-2.95 2.56.888 3.804L9 12.022z"
      ></path>
    </svg>
    </button>
  );
};

export default LikeButtonNew;
